// time ago pipe


import { Pipe, PipeTransform, OnDestroy } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import'rxjs/add/observable/interval';
import'rxjs/add/operator/startWith';

import distanceInWordsToNow from 'date-fns/distance_in_words_to_now';

import { DatePipeManager, AgoPipeOptions } from '../providers/date-pipe-manager';
export class TimeAgoPipe implements PipeTransform, OnDestroy {
private refresher: Subscription = new Subscription();
private refreshNow = false;
private previousAgoExpression = '';
private options: AgoPipeOptions;
/**
 * @param {?} manager
 */
constructor(manager: DatePipeManager) {
        this.options = manager.getAgoPipeOptions();
        this.refresher = Observable.interval(this.options.refreshRate).startWith(0).subscribe(_ => this.refreshNow = true);
    }
/**
 * @return {?}
 */
ngOnDestroy() {
        this.refresher.unsubscribe();
    }
/**
 * @param {?} inputTime
 * @return {?}
 */
transform(inputTime: string | number | Date) {
        if (this.refreshNow) {
            this.refreshNow = false;
            const /** @type {?} */ newAgoExpression = this.agoExpression(inputTime);
            this.previousAgoExpression = newAgoExpression;
            return newAgoExpression;
        } else {
            return this.previousAgoExpression;
        }
    }
/**
 * @param {?} inputTime
 * @return {?}
 */
private agoExpression(inputTime: string | number | Date): string {
        const /** @type {?} */ timeText = distanceInWordsToNow(inputTime, {includeSeconds: this.options.includeSeconds});
        const /** @type {?} */ expression = this.options.prefix + timeText + this.options.suffix;
        return expression;
    }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{name: 'ago', pure: false}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: DatePipeManager, },
];
}

function TimeAgoPipe_tsickle_Closure_declarations() {
/** @type {?} */
TimeAgoPipe.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TimeAgoPipe.ctorParameters;
/** @type {?} */
TimeAgoPipe.prototype.refresher;
/** @type {?} */
TimeAgoPipe.prototype.refreshNow;
/** @type {?} */
TimeAgoPipe.prototype.previousAgoExpression;
/** @type {?} */
TimeAgoPipe.prototype.options;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
